export const OpenStreetMapTypeValues = {
  NODE: 'node',
  WAY: 'way',
} as const;

export type OpenStreetMapType = (typeof OpenStreetMapTypeValues)[keyof typeof OpenStreetMapTypeValues];

export interface OpenStreetMapPoi {
  id: string;
  lat?: number;
  lon?: number;
  center?: {
    lat: number;
    lon: number;
  };
  nodes?: number[];
  tags: {
    name?: string;
    [key: string]: string | undefined;
  };
  type: OpenStreetMapType;
}
